import { render, staticRenderFns } from "./PerformanceStatsTable.vue?vue&type=template&id=35b31678"
import script from "./PerformanceStatsTable.vue?vue&type=script&lang=js"
export * from "./PerformanceStatsTable.vue?vue&type=script&lang=js"
import style0 from "./PerformanceStatsTable.vue?vue&type=style&index=0&id=35b31678&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports